<template>
    <experiment-relationship-config-types-list
        :experiment-relationship-configs="experimentRelationshipConfigs"
        @save-experiment-relationship-config="handleSaveExperimentRelationshipConfig"
        @deleted-experiment-relationship-config="fetchRelationshipConfigsForSelectedSchemaConfig"
    />
</template>
<script setup lang="ts">

import { ref } from "vue";
import { withLoadingScreen } from "@/lib/loading";
import { SavedSchemaConfigDTO } from "@/services/schemas/manageSchemasAPI";
import {
    ExperimentSetupRelationshipConfig,
    ManageExperimentSetupRelationshipConfigDTO,
    RelationshipConfigsForType,
    SavedExperimentSetupRelationshipConfig,
} from "@/services/experimentRelationships/models";
import {
    buildExperimentConfigRelationshipAPIForSchemaConfig
} from "@/services/experimentRelationships/experimentRelationshipConfigsAPI";
import ExperimentRelationshipConfigTypesList
    from "@/components/ExperimentRelationshipConfigs/ExperimentRelationshipConfigTypesList.vue";

const { schemaConfig } = defineProps<{
    schemaConfig: SavedSchemaConfigDTO;
}>();

const schemaConfigRelationshipConfigAPI = buildExperimentConfigRelationshipAPIForSchemaConfig(schemaConfig.id);
const experimentRelationshipConfigs = ref<RelationshipConfigsForType<ManageExperimentSetupRelationshipConfigDTO>[]>([]);

async function handleSaveExperimentRelationshipConfig(targetConfig: ExperimentSetupRelationshipConfig | SavedExperimentSetupRelationshipConfig) {
    await withLoadingScreen(async () => {
        await schemaConfigRelationshipConfigAPI.save({
            ...targetConfig,
            schemaConfigId: schemaConfig.id
        });

        await fetchRelationshipConfigsForSelectedSchemaConfig();
    });
}


async function fetchRelationshipConfigsForSelectedSchemaConfig() {
    await withLoadingScreen(async () => {
        experimentRelationshipConfigs.value = await schemaConfigRelationshipConfigAPI.fetchAllDTOs();
    })
}

fetchRelationshipConfigsForSelectedSchemaConfig();
</script>
